
import Vue from "vue";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import filters from "@/filters";

import About from "./school_profile/About.vue";
import Contact from "./school_profile/Contact.vue";
import ModalAbout from "./school_profile/ModalAbout.vue";

@Component({
  filters,
  components: {
    About,
    Contact,
    ModalAbout,
  },
})
export default class SchoolProfile extends Vue {
  /* VUEX */

  // ACTION
  @Action("actionSelectCurrentSchool", { namespace: "academy" })
  private actionSelectCurrentSchool: any;

  // STATE
  @State("school", { namespace: "academy" })
  private school: any;
  @State("locale")
  private locale: string;

  /* INITIALIZATION */

  private tabAbout: boolean = true;
  private isShowModalAbout: boolean = false;
  private isShowModalContactInfo:boolean = false

  constructor() {
    super();
  }

  private created() {
    this.actionSelectCurrentSchool();
  }

  /* METHODS */
}
